<template>
  <div class="box group-container">
    <div
      class="media is-vertical-center group-header"
      @click.stop="toggleCollapsed"
    >
      <div class="media-left">
        <img v-if="!collapsed" src="../../assets/svg/chevron-upx2.svg" />
        <img v-else src="../../assets/svg/chevron-downx2.svg" />
      </div>

      <div class="media-content">
        <p class="subtitle is-6">
          {{ group.name }}
        </p>
      </div>

      <div class="media-right">
        <nav class="level is-mobile">
          <div class="level-left">
            <router-link
              v-if="group.hasGeometry"
              :to="{
                name: 'map',
                params: { projectSchema: projectSchema },
                query: { section: sectionId, docKey: group.key },
              }"
              class="level-item"
              @click.native="$event.stopImmediatePropagation()"
            >
              <span class="icon">
                <img src="../../assets/svg/map_icon_blue.svg" />
              </span>
              <span>Посмотреть на карте</span>
            </router-link>
            <span
              class="tag is-rounded level-item"
              title="Количество документов"
            >
              {{ group.count }}
            </span>
          </div>
        </nav>
      </div>
    </div>

    <fetch-group-docs
      v-if="!collapsed"
      :project-schema="projectSchema"
      :section-id="sectionId"
      :group-key="group.key"
    >
      <template slot-scope="{ documents }">
        <div class="group-docs">
          <hr />
          <GisogdSectionDocs
            :docs="documents"
            :project-schema="projectSchema"
          ></GisogdSectionDocs>
        </div>
      </template>
    </fetch-group-docs>
  </div>
</template>
<script>
import GisogdSectionDocs from "./Docs";
import FetchGroupDocs from "./FetchGroupDocs";

export default {
  props: {
    projectSchema: {
      required: true,
      type: String,
    },
    sectionId: {
      required: true,
      type: String,
    },
    group: {
      required: true,
      type: Object,
    },
    isOpen: {
      default: false,
    },
  },
  data() {
    return {
      collapsed: !this.isOpen,
    };
  },
  components: {
    GisogdSectionDocs,
    FetchGroupDocs,
  },
  computed: {
    url() {
      return `v1/${this.projectSchema}/gisogddocgroupdocs/${this.sectionId}/${this.group.key}`;
    },
  },
  methods: {
    toggleCollapsed() {
      this.collapsed = !this.collapsed;
      this.$emit("change-collapsed-group", {
        group: this.group,
        collapsed: this.collapsed,
      });

      if (this.collapsed) {
        this.$emit("group-collapsed", this.group);
      } else {
        this.$emit("group-opened", this.group);
      }
    },
  },
};
</script>
<style>
.group-container {
  margin-bottom: 0.5rem !important;
}

.group-header {
  cursor: pointer;
}

.group-docs {
  margin-top: 1.25rem;
}
</style>